// extracted by mini-css-extract-plugin
export default {"highlighted-text":"style__highlighted-text___OxF2E"};